import { useContext } from 'react';
import { IPrimarySlotPropsMap } from 'redux-state/layout/types.layout.js';
import { MapSlotContext } from './map-slot-context.js';

// Moves zoom and map in proportion based on if the mapSlot area has content
const MapSlotWrapperMapClass = ({ filteredPrimaryConfig }: { filteredPrimaryConfig: IPrimarySlotPropsMap }) => {
  const { mapSlot } = useContext(MapSlotContext);

  const hasLeftSlotContent =
    mapSlot?.length || filteredPrimaryConfig.leftMajor.modules.length || filteredPrimaryConfig.leftMinor.modules.length;

  if (hasLeftSlotContent) {
    return 'u-lg-width2of3 u-xl-width6of12';
  }
  return 'u-lg-width3of3 u-xl-width9of12';
};

/**
 * Renders map layout with slots over the top of map canvas
 * MapSlot callback is passed to map which is used to update map slot on icon select
 */
export const MapWrapper = ({
  /** searchBarOffset increases when searchbar is displaying */
  filteredPrimaryConfig,
  children,
}: {
  filteredPrimaryConfig: IPrimarySlotPropsMap;
  children: JSX.Element | null;
}) => {
  const mapClass = MapSlotWrapperMapClass({ filteredPrimaryConfig });

  return <div className={`Grid-cell Map-wrapper ${mapClass}`}>{children}</div>;
};
